export const formatWhatsappPhoneNumber = (
  phoneNumber: string,
  shouldMask: boolean
): string => {
  if (!shouldMask || phoneNumber.length <= 7) return `+${phoneNumber}`;

  const start = phoneNumber.slice(0, 3);
  const end = phoneNumber.slice(-4);
  const stars = "*".repeat(phoneNumber.length - 7);

  return `+${start}${stars}${end}`;
};
